import { action, thunk, thunkOn } from 'easy-peasy'

import { MessageModel } from '.'

export const message: MessageModel = {
	type: null,
	title: null,
	message: '',
	open: false,

	setType: action((state, payload) => {
		state.type = payload
	}),
	setTitle: action((state, payload) => {
		state.title = payload
	}),
	setMessage: action((state, payload) => {
		state.message = payload
	}),
	setOpen: action((state, payload) => {
		state.open = payload
	}),
	info: action((state, payload) => {
		state.type = 'info'
		state.message = payload
	}),
	success: action((state, payload) => {
		state.type = 'success'
		state.message = payload
	}),
	error: action((state, payload) => {
		state.type = 'error'
		state.message = payload
	}),

	present: thunk(action => {
		action.setOpen(true)
	}),
	close: thunk(action => {
		action.setOpen(false)
	}),

	onError: thunkOn(
		(_, storeAction) => [
			storeAction.message.info,
			storeAction.message.success,
			storeAction.message.error
		],
		(action, target) => {
			if (target.payload) {
				const message: string = target.payload
				action.setMessage(message)
				action.present()
			} else {
				action.setType('none')
			}
		}
	)
}
